module.exports = __webpack_public_path__ + "static/pe3-9b70a9fc6478604dc990fdf2c2bb29fb.png";